import React, { useState, useEffect } from 'react';
import { appsApi } from '../services/api';

const PRODUCTIVITY_COLORS: Record<string, string> = {
  productive: 'var(--green)',
  neutral: 'var(--blue)',
  unproductive: 'var(--red)',
};

export function AppsPage() {
  const [apps, setApps] = useState<any[]>([]);
  const [topApps, setTopApps] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const today = new Date().toISOString().split('T')[0];

  useEffect(() => {
    Promise.all([appsApi.getCatalog(), appsApi.getTopApps(today)])
      .then(([catalog, top]) => { setApps(catalog); setTopApps(top); })
      .finally(() => setLoading(false));
  }, []);

  const handleProductivityChange = async (id: number, productivity: string) => {
    await appsApi.updateProductivity(id, productivity);
    setApps(prev => prev.map(a => a.id === id ? { ...a, productivity } : a));
  };

  return (
    <div style={{ padding: '28px 32px' }}>
      <div className="page-header">
        <div>
          <h1 className="page-title">Aplicaciones</h1>
          <p className="page-subtitle">Clasificación de productividad</p>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
        {/* Top apps today */}
        <div className="card">
          <h3 style={{ fontSize: 13, fontWeight: 700, marginBottom: 14 }}>📊 Más usadas hoy</h3>
          {topApps.length === 0 ? (
            <div style={{ color: 'var(--text3)', fontSize: 12 }}>Sin datos hoy</div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {topApps.slice(0, 10).map((app: any, i) => {
                const h = Math.floor(app.totalSecs / 3600);
                const m = Math.floor((app.totalSecs % 3600) / 60);
                const color = PRODUCTIVITY_COLORS[app.productivity] || 'var(--text3)';
                return (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{ width: 6, height: 6, borderRadius: '50%', background: color, flexShrink: 0 }} />
                    <div style={{ flex: 1, fontSize: 12 }}>{app.appName}</div>
                    <div style={{ fontSize: 11, color: 'var(--text3)' }}>{app.userCount} usuarios</div>
                    <div style={{ fontSize: 11, color: 'var(--accent)', fontWeight: 600 }}>
                      {h > 0 ? `${h}h ` : ''}{m}m
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* Catalog */}
        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          <div style={{ padding: '16px 20px', borderBottom: '1px solid var(--border)' }}>
            <h3 style={{ fontSize: 13, fontWeight: 700 }}>📋 Catálogo de apps</h3>
          </div>
          <div style={{ maxHeight: 400, overflow: 'auto' }}>
            <table className="table">
              <thead>
                <tr>
                  <th>Aplicación</th>
                  <th>Categoría</th>
                  <th>Productividad</th>
                </tr>
              </thead>
              <tbody>
                {apps.map(app => (
                  <tr key={app.id}>
                    <td style={{ fontSize: 12 }}>{app.appName}</td>
                    <td style={{ fontSize: 11, color: 'var(--text3)' }}>{app.category || '—'}</td>
                    <td>
                      <select
                        className="input"
                        style={{ width: 130, padding: '3px 8px', fontSize: 11 }}
                        value={app.productivity}
                        onChange={e => handleProductivityChange(app.id, e.target.value)}
                      >
                        <option value="productive">✅ Productivo</option>
                        <option value="neutral">🔵 Neutral</option>
                        <option value="unproductive">❌ Improductivo</option>
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
